import { Box, Flex, Stack, Circle, useMediaQuery } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { useCookieConsent } from '../cookieConsent';

const FooterLink = ({ link, isLast, isLargerThanMD, footerColorMode }) => {
  const content = (
    <Box
      color={footerColorMode === 'dark' ? 'white' : 'secondaryDark'}
      fontSize="12px"
      pos="relative"
    >
      {link.wording}
      {!isLast && !isLargerThanMD && (
        <Circle
          size="4px"
          bg="brand"
          pos="absolute"
          right="-14px"
          top="6px"
        />
      )}
    </Box>
  );

  if (link.onClick) {
    return (
      <Box as="button" onClick={link.onClick} cursor="pointer">
        {content}
      </Box>
    );
  }

  return (
    <NavLink
      to={link.url}
      className={({ isActive }) => (isActive ? 'active' : 'inactive')}
    >
      {content}
    </NavLink>
  );
};

const Footer = (props) => {
  const [isLargerThanMD] = useMediaQuery('(min-width: 48em)');
  const { showPreferences, isGdprRegion } = useCookieConsent();

  const policyLinks = [
    {
      wording: 'Privacy Policy',
      url: 'https://passentry.com/privacy-policy/',
    },
    {
      wording: 'Cookie Policy',
      url: 'https://passentry.com/cookie-policy/',
    },
    ...(isGdprRegion
      ? [{ wording: 'Cookie Settings', onClick: showPreferences }]
      : []),
  ];

  const footerLinks = [
    {
      segment: [
        {
          wording: 'Terms of Service',
          url: 'https://passentry.com/terms-of-service',
        },
        {
          wording: 'Terms and Conditions',
          url: 'https://passentry.com/terms-and-conditions/',
        },
      ],
    },
    {
      segment: policyLinks,
    },
    {
      segment: [
        {
          wording: 'API Documentation',
          url: 'https://docs.passentry.com/',
        },
        { wording: 'API Status', url: 'https://status.passentry.com/' },
        {
          wording: 'Give Feedback',
          url: 'https://wpxnht5lj5w.typeform.com/to/BwU415Nj',
        },
        { wording: 'Contact Us', url: 'mailto:sales@passentry.com' },
      ],
    },
  ];

  return (
    <Flex
      as="footer"
      role="contentinfo"
      flexDirection={{ base: 'column-reverse', xl: 'row' }}
      justifyContent="center"
      pb={10}
      pt={14}
      px={{ base: 4, md: 2 }}
      w="100%"
      position="relative"
      flexShrink={0}
    >
      <Flex
        flexDirection={{ base: 'column', xl: 'row' }}
        justifyContent={{ base: 'center', md: 'left' }}
        className="footerNav"
      >
        {footerLinks.map((footerSegment, segIndex) => (
          <Stack
            key={segIndex}
            flexShrink={0}
            direction="row"
            justifyContent={{ base: 'center', xl: 'left' }}
            spacing={{ base: '24px', xl: '30px' }}
            mb={{ base: '12px', xl: '0px' }}
            mr={{ base: '0', md: segIndex !== 2 ? '30px' : 0 }}
          >
            {footerSegment.segment.map((link, linkIndex) => (
              <FooterLink
                key={linkIndex}
                link={link}
                isLast={linkIndex === footerSegment.segment.length - 1}
                isLargerThanMD={isLargerThanMD}
                footerColorMode={props.footerColorMode}
              />
            ))}
          </Stack>
        ))}
      </Flex>
    </Flex>
  );
};

export default Footer;
